import { Alert, AlertIcon } from "@chakra-ui/react";
import { Row, Col } from "antd";
import useGetSolicitacaoCadastroById from "core/features/SolicitacaoCadastro/hooks/useGetSolicitacaoCadastroById";
import { useBreadcrumb } from "core/features/breadcrumbs";
import { useParams } from "react-router-dom";
import { useLoading } from "ui/components/GlobalLoading";
import SolicitacaoAcoes from "./components/SolicitacaoAcoes";
import PageHeader from "components/Page/PageHeader";
import Documentos from "./components/Documentos";
import PessoaInfo from "./components/PessoaInfo";
import TimelineHistorico from "./components/TimelineHistorico";
import CardDefault from "components/Cards/CardDefault";
import { useCurrentAuth } from "features/auth/auth.store";
import Container from "components/Container";

function SolicitacaoCadastroDetalhes() {
  const { auth } = useCurrentAuth();
  const params = useParams<{ id: string }>();
  const { data, isLoading, refetch } = useGetSolicitacaoCadastroById(params.id);

  useBreadcrumb([
    { name: "Solicitações", url: "/administracao/solicitacao-cadastro" },
    {
      name: data?.pessoa.nome
        ? "Solicitação de " + data.pessoa.nome
        : "Carregando...",
      url: `/administracao/solicitacao-cadastro/${params.id}`,
    },
  ]);

  useLoading(isLoading);

  return (
    <>
      <Container pb="32px">
        <PageHeader title="Analise de Cadastro" />
        {data && data.pessoaAnalistaId === auth.pessoaId ? (
          <SolicitacaoAcoes
            status={data.statusId}
            id={data.id}
            refetch={refetch}
          />
        ) : null}

        {data && data.pessoaAnalistaId !== auth.pessoaId ? (
          <Alert mb="32px" status="warning">
            <AlertIcon />
            Este cadastro ja está sendo analisado por outra pessoa!
          </Alert>
        ) : null}

        <Row gutter={21}>
          <Col sm={24}> {data ? <PessoaInfo data={data} /> : null}</Col>
          <Col sm={10}>{data ? <Documentos data={data} /> : null}</Col>
          <Col sm={14}>
            <CardDefault>
              {data?.logs?.map((item) => (
                <TimelineHistorico data={item} />
              ))}
            </CardDefault>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default SolicitacaoCadastroDetalhes;
